import React, { useState } from "react";

import './index.scss';


import Header from "../header/header";



export const PageHeading = () =>
{



    return (
        <div className="">

            <Header />
        </div >
    );
};